import { render, staticRenderFns } from "./AppChartPie.vue?vue&type=template&id=30901cbc&scoped=true&"
import script from "./AppChartPie.vue?vue&type=script&lang=js&"
export * from "./AppChartPie.vue?vue&type=script&lang=js&"
import style0 from "./AppChartPie.vue?vue&type=style&index=0&id=30901cbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30901cbc",
  null
  
)

export default component.exports